export const SHORTCUTS_DATA = [
	{
		shortcut: "Upload Files & Folders",
		icon: "drive_folder_upload",
		color: "green",
	},
	{
		shortcut: "Create an Event",
		icon: "event",
		color: "amber",
	},
	{
		shortcut: "Create a Contact",
		icon: "account_circle",
		color: "blue",
	},
	{
		shortcut: "Start a Conversation",
		icon: "chat",
		color: "purple",
	},
	{
		shortcut: "Add a Todo List",
		icon: "task_alt",
		color: "red",
	},
	{
		shortcut: "Generate Reports",
		icon: "article",
		color: "teal",
	},
	{
		shortcut: "Compose a Mail",
		icon: "mail",
		color: "cyan",
	},
	{
		shortcut: "Check Analytics",
		icon: "analytics",
		color: "indigo",
	},
	{
		shortcut: "Upload Photos",
		icon: "image",
		color: "orange",
	},
	{
		shortcut: "Update Profile Status",
		icon: "sentiment_satisfied_alt",
		color: "lime",
	},
	{
		shortcut: "Report a Bug/Issue",
		icon: "bug_report",
		color: "lime",
	},
];
